import './HeroStatsRow.scss';
import { memo, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { activePartnerAtom, locationCountAtom } from '../../../../state';
import { AdjustableComponent } from '../../../../utils/hooks/useClasses';
import {
  useGetAverageHealthScoreHero,
  useGetPartnerLatestStatsHero,
} from '../../services/healthcheckServices';
import {
  HeroStatType,
  emptyHeroStats,
  getEmptyStat,
  makeHeroStats,
} from '../../services/heroStatsProc';
import HeroStatsCell from '../HeroStatsCell/HeroStatsCell';

type HeroStatsProps = {};
type HeroStatsStyles = {};

const HeroStatsRow: AdjustableComponent<
  HeroStatsProps,
  HeroStatsStyles
> = () => {
  const { t } = useTranslation();
  const [heroStats, setHeroStats] = useState(emptyHeroStats);
  const [ready, setReady] = useState(false);

  const activePartner = useRecoilValue(activePartnerAtom);

  const {
    partnerLatestStatsHeroLoading,
    partnerLatestStatsArrayHero,
  } = useGetPartnerLatestStatsHero(activePartner?.id ? activePartner.id : '');

  const {
    averageHealthScoreHeroLoading,
    averageHealthScoreArrayHero,
  } = useGetAverageHealthScoreHero();

  const setLocationCount = useSetRecoilState(locationCountAtom);

  useEffect(() => {
    if (!partnerLatestStatsHeroLoading && activePartner) {
      if (
        partnerLatestStatsArrayHero[0] &&
        partnerLatestStatsArrayHero[0].location_count
      ) {
        setLocationCount(partnerLatestStatsArrayHero[0].location_count);
      }
    }
  }, [partnerLatestStatsHeroLoading, activePartner]);

  useEffect(() => {
    if (
      !averageHealthScoreHeroLoading &&
      averageHealthScoreArrayHero &&
      !partnerLatestStatsHeroLoading &&
      partnerLatestStatsArrayHero &&
      activePartner
    ) {
      const heroStatsObj: HeroStatType[] = makeHeroStats(
        averageHealthScoreArrayHero,
        partnerLatestStatsArrayHero,
        t,
      );
      setHeroStats(heroStatsObj);
      setReady(true);
    }
  }, [
    averageHealthScoreArrayHero,
    partnerLatestStatsHeroLoading,
    averageHealthScoreHeroLoading,
    partnerLatestStatsArrayHero,
    activePartner,
  ]);

  if (heroStats && heroStats.length < 1) {
    const emptyHeroStats: HeroStatType[] = [];
    emptyHeroStats.push(getEmptyStat('heroStats.avgHealthScore'));
    emptyHeroStats.push(getEmptyStat('heroStats.typHealthScore'));
    emptyHeroStats.push(getEmptyStat('heroStats.locationsWithCriticalIssues'));
    emptyHeroStats.push(
      getEmptyStat('heroStats.locationsWithNonCriticalIssues'),
    );
    emptyHeroStats.push(getEmptyStat('heroStats.suppressedOfflineLocations'));
    setHeroStats(emptyHeroStats);
  }

  return (
    <div className="HeroStatsRow">
      <div className="HeroStatsRow__container">
        {heroStats.map((stat, i) => (
          <HeroStatsCell
            key={stat.id || stat.label || i}
            label={stat.label}
            value={stat.value}
            id={stat.valueId}
            unit={stat.unit}
            secondaryValue={stat.secondaryValue}
            ready={ready}
            tooltipText={stat.tooltipText}
            undefinedText={stat.undefinedText}
          />
        ))}
      </div>
    </div>
  );
};

export default memo(HeroStatsRow);
